import React from "react";
import { Paper, Table, TableBody, TableContainer } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AutomationListItem from "./AutomationListItem";
import { IAutomation } from "./types";
import FloatingActionButton from "../../Components/FloatingActionButton";

interface IAutomationsPanelProps {
  automations: IAutomation[];
}

const AutomationList = (props: IAutomationsPanelProps) => {
  const { automations } = props;
  const navigate = useNavigate();
  const handleAddAutomation = () => navigate("/automations/-1");
  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableBody>
            {automations
              .sort(function (a: IAutomation, b: IAutomation) {
                return a.name.localeCompare(b.name);
              })
              .map((automation) => (
                <AutomationListItem
                  key={automation.id}
                  automation={automation}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <FloatingActionButton
        iconName="plus"
        onClick={handleAddAutomation}
        data-cy="automation-add"
      />
    </>
  );
};

export default AutomationList;
